// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b1109f66","453":"f4635ff7","455":"05758b86"}[chunkId] + ".chunk.js";
};